import type { ReactNode } from 'react';
import { formatIdentifier } from '../../../../react-commons/utils/utilFunctions';
import type { PropertyDetailsResource } from '../../resource/resources/propertyDetailsResource';

export const getLabelFromPropertyDetails = (
    propertyDetails: PropertyDetailsResource | Array<PropertyDetailsResource> | undefined,
    fallback?: ReactNode
) => {
    return (
        Array.isArray(propertyDetails) ?
            propertyDetails[0]?.displayName ?
                propertyDetails[0].displayName
            :   formatIdentifier(propertyDetails[0]?.propertyName ?? '')
        : propertyDetails ?
            propertyDetails.displayName ?
                propertyDetails.displayName
            :   formatIdentifier(propertyDetails.propertyName)
        :   fallback
    );
};
